import MetaMomentumChart from "./MetaMomentumChart";
import PoissonChart from "./PoissonChart";

export default function GameCard({ game }) {
  return (
    <div className="border p-4 rounded shadow">
      <h2 className="font-semibold">
        {game.home_team} vs {game.away_team}
      </h2>
      <p>{game.league_name} - {game.stadium}</p>
      <p>Data: {new Date(game.event_date).toLocaleString("pt-BR")}</p>
      {game.status && <p>Status: {game.status}</p>}
      {game.home_score !== undefined && (
        <p>Placar: {game.home_score} - {game.away_score}</p>
      )}

      {/* Indicadores */}
      {game.metaMomentum !== undefined && (
        <MetaMomentumChart metaMomentum={game.metaMomentum} />
      )}
      {game.lambda !== undefined && (
        <PoissonChart lambda={game.lambda} />
      )}
    </div>
  );
}
